const items = [
  "Soft-Wash Certified",
  "Surface-Safe Detergents",
  "Fully Insured & Bonded",
  "Reclaim Water Practices",
  "Local Family Operated",
  "Same-Week Scheduling",
  "Eco-Conscious Solutions",
  "Commercial · Residential",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-white/10 bg-[#09090B] py-8 overflow-hidden relative"
    >
      <div className="flex w-[200%] animate-marquee whitespace-nowrap">
        {[...items, ...items, ...items].map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-12 pr-12 font-mono-small text-white/50"
          >
            <span className="text-[#E5D0A1]">✦</span>
            <span>{t}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
